import * as $ from "jquery";

export default class Accordion {
	wrapper: HTMLElement;

	speed: number = 400;

	constructor(wrapper:HTMLElement) {
		this.wrapper = wrapper;
		
		$('.accordion__item').each((i, el) => {
			this.watch(<HTMLElement>el);
		});
	}

	watch(item:HTMLElement) {
		const title = item.querySelector(".accordion__title");
		title.addEventListener("click", (e) => {
			e.preventDefault();
			this.toggleItem(item);
		});
	}

	toggleItem(item:HTMLElement) {
		const content = item.querySelector('.accordion__content');
		if (item.classList.contains('open')) {
			item.classList.remove('open');
			$(content).stop().slideUp(this.speed);
		} else {
			item.classList.add('open');
			$(content).stop().slideDown(this.speed);
		}
	}
}